import { useRef, useState } from 'react';

import { RigidBody } from '@react-three/rapier';
import { useFrame } from '@react-three/fiber';

import { Tube } from '@game/Tube';

export function BlockLimbo({ position = [0, 0, 0], bad = false }) {
    const obstacleRef = useRef();
    const [timeOffset] = useState(() => Math.random() * Math.PI * 2);

    useFrame((state) => {
        const time = state.clock.getElapsedTime();

        const y = Math.sin(time + timeOffset) + 1.15;
        if (obstacleRef.current) obstacleRef.current.setNextKinematicTranslation({ x: position[0], y: position[1] + y, z: position[2] });
    })

    return (
        <group position={position}>
            <RigidBody ref={obstacleRef} type="kinematicPosition" position={[0, 0.3, 0]} restitution={0.2} friction={0}>
                <Tube bad={bad} />
            </RigidBody>
        </group>
    )
}